import React from 'react';
import Link from 'next/link';

function Cta() {
    return (
        <div className={'flex items-center text-nowrap justify-center mt-8 font-bold text-sm'}>
            <Link
                href={'#producs-card'}
                className='bg-[#EEAC43] lg:px-20 px-16 flex justify-center items-center py-2 rounded-2xl text-primary transition-all hover:bg-transparent border border-[#EEAC43] hover:text-[#EEAC43] cursor-pointer'
            >
                ثبت نام دوره
            </Link>
            <Link
                href={'#cta-section'}
                className={'text-[#EEAC43] hover:brightness-110 px-5 lg:px-10'}
            >
                درخواست مشاوره
            </Link>
        </div>
    );
}

export default Cta;
